import API from '../../../../../services/api';
import { headers } from '../helpers/functionalities';

export const API_MENSAJES = {
    getMensajes: async () => {
        return await API.get('/mensajes').then(res => res.data);
    },
    newMensaje: async (mensaje) => {
        return API.post('/mensajes', mensaje, headers).then(res => res.data);
    },
    updateMensaje: async (idMensaje, mensaje) => {
        return API.post('/mensajes/' + idMensaje + '/update', mensaje).then(res => res.data);
    },
    enableDisableMensaje: async (mensaje) => {
        return API.post('/mensajes/' + mensaje.id +'/status', mensaje).then(res => res.data);
    },
    deleteMensaje: async (idMensaje) => {
        return API.delete('/mensajes/' + idMensaje).then(res => res.data);
    }
}